function hexToRgbString(hex) {
  hex = hex.replace('#', '');
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map(c => c + c)
      .join('');
  }
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return `rgb(${r}, ${g}, ${b})`;
}

function rgbToLab(rgb) {
  let [r, g, b] = rgb
    .match(/\d+/g)
    .map(Number)
    .map(c => c / 255);
  [r, g, b] = [r, g, b].map(
    c => (c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92) * 100
  );
  let x = (r * 0.4124564 + g * 0.3575761 + b * 0.1804375) / 95.047;
  let y = (r * 0.2126729 + g * 0.7151522 + b * 0.072175) / 100;
  let z = (r * 0.0193339 + g * 0.119192 + b * 0.9503041) / 108.883;
  [x, y, z] = [x, y, z].map(c =>
    c > 0.008856 ? Math.pow(c, 1 / 3) : 7.787 * c + 16 / 116
  );
  return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
}

function deltaE00(lab1, lab2) {
  let [L1, a1, b1] = lab1,
    [L2, a2, b2] = lab2;
  let avgL = (L1 + L2) / 2;

  let C1 = Math.sqrt(a1 * a1 + b1 * b1);
  let C2 = Math.sqrt(a2 * a2 + b2 * b2);
  let avgC = (C1 + C2) / 2;

  let G =
    0.5 *
    (1 - Math.sqrt(Math.pow(avgC, 7) / (Math.pow(avgC, 7) + Math.pow(25, 7))));
  let a1p = a1 * (1 + G);
  let a2p = a2 * (1 + G);

  let C1p = Math.sqrt(a1p * a1p + b1 * b1);
  let C2p = Math.sqrt(a2p * a2p + b2 * b2);
  let avgCp = (C1p + C2p) / 2;

  let h1p = Math.atan2(b1, a1p) * (180 / Math.PI);
  if (h1p < 0) h1p += 360;
  let h2p = Math.atan2(b2, a2p) * (180 / Math.PI);
  if (h2p < 0) h2p += 360;

  let deltahp =
    Math.abs(h1p - h2p) > 180
      ? h2p <= h1p
        ? h2p - h1p + 360
        : h2p - h1p - 360
      : h2p - h1p;

  let deltaHp =
    2 * Math.sqrt(C1p * C2p) * Math.sin((deltahp * Math.PI) / 180 / 2);

  let T =
    1 -
    0.17 * Math.cos(((h1p + h2p - 30) * Math.PI) / 180) +
    0.24 * Math.cos((2 * (h1p + h2p) * Math.PI) / 180) +
    0.32 * Math.cos((3 * (h1p + h2p + 6) * Math.PI) / 180) -
    0.2 * Math.cos((4 * (h1p + h2p - 63) * Math.PI) / 180);

  let deltaLp = L2 - L1;
  let deltaCp = C2p - C1p;

  let SL =
    1 +
    (0.015 * Math.pow(avgL - 50, 2)) / Math.sqrt(20 + Math.pow(avgL - 50, 2));
  let SC = 1 + 0.045 * avgCp;
  let SH = 1 + 0.015 * avgCp * T;

  let deltaTheta = 30 * Math.exp(-Math.pow((h1p + h2p - 275) / 25, 2));
  let RC =
    2 * Math.sqrt(Math.pow(avgCp, 7) / (Math.pow(avgCp, 7) + Math.pow(25, 7)));
  let RT = -RC * Math.sin((2 * deltaTheta * Math.PI) / 180);

  let KL = 1.0;
  let KC = 2.0;
  let KH = 0.5;

  let result = Math.sqrt(
    Math.pow(deltaLp / (KL * SL), 2) +
      Math.pow(deltaCp / (KC * SC), 2) +
      Math.pow(deltaHp / (KH * SH), 2) +
      RT * (deltaCp / SC) * (deltaHp / SH)
  );

  let isNeutral1 = C1 < 20;
  let isNeutral2 = C2 < 20;

  if (isNeutral1 !== isNeutral2) {
    result += 30;
  } else if (isNeutral1 && isNeutral2) {
    result -= 5;
  }

  return result;
}
function colorDifferenceDeltaE00(hexColor1, hexColor2) {
  const rgb1 = hexToRgbString(hexColor1);
  const rgb2 = hexToRgbString(hexColor2);

  return deltaE00(rgbToLab(rgb1), rgbToLab(rgb2));
}

function bestMatchingComparedColor(selectedColor, compareColorArray) {
  const closest = compareColorArray.reduce(
    (best, current) => {
      const diff = colorDifferenceDeltaE00(selectedColor, current.hex);
      return diff < best.diff ? { element: current, diff } : best;
    },
    { element: null, diff: Infinity }
  );

  return closest.element ? closest.element.id : null;
}

export { bestMatchingComparedColor };
